import { render, staticRenderFns } from "./scope37.vue?vue&type=template&id=0bbe3c34&scoped=true"
import script from "./scope37.vue?vue&type=script&lang=js"
export * from "./scope37.vue?vue&type=script&lang=js"
import style0 from "./scope37.vue?vue&type=style&index=0&id=0bbe3c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe3c34",
  null
  
)

export default component.exports